import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  messagesSentRequest,
  messagesSentFailure,
  messagesSentSuccess,
} from '../reducers/messagesList';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* messagesSentListAxios() {
  
  const state = yield select(fullState => fullState);
  
  const userId = state.loginReducer.isTeamLeader
    ? state.teamMembersReducer.selectedTeamMemberId
    : state.loginReducer.user.userId;
   
  const { token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}${userId}/messageSent`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerMessagesSentListSaga() {
  try {
    const response = yield call(messagesSentListAxios);

    const responseFromMessagesSentList = response.data;
    yield put(messagesSentSuccess(responseFromMessagesSentList));
  } catch (error) {
    yield put(messagesSentFailure(error));
  }
}

export function* watcherMessagesSentListSaga() {
  yield takeLatest(messagesSentRequest().type, workerMessagesSentListSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_messagesSentList.js